import { SUCCESSFUL_GET_PAYMENTMETHOD } from "./actionConst";

const initialState = {
    items: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SUCCESSFUL_GET_PAYMENTMETHOD:
            return {
                ...state,
                items: action.payload
            }
        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/paymentmethod/paymentmethodReducer.js